import DisplayItemHelper from '../../../util/DisplayItemHelper'
import DisplayItem from '../../../Components/DisplayItems/DisplayItem.jsx'

import Checkbox from '@mui/material/Checkbox'
import Stack from '@mui/material/Stack'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import Tooltip from '@mui/material/Tooltip'
import { alpha } from '@mui/material/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/pro-duotone-svg-icons/faBell'
import { faEdit } from '@fortawesome/pro-duotone-svg-icons/faEdit'
import { faEye } from '@fortawesome/pro-duotone-svg-icons/faEye'
import * as React from 'react'
import { ContentDossierSend } from '@/feature/ContentDossier/Toolbar'
import { LoadingDefault } from '@/shared/ui/loading'
import { faEyeSlash } from '@fortawesome/pro-duotone-svg-icons/faEyeSlash'
import { CompactButton } from '@/shared/ui/buttons'
import { StyledTableRow } from '@/shared/ui/tables'
import { isInteractiveClick } from '@/util/clickGuards'

interface ContentDossierIndexBodyProps {
    listItems: Array<IDisplayField>
    dossiers: Array<any>
    contents: Array<any>
    subscriptions: Array<any>
    actionBtns: Array<any>
    loadingContent: boolean | null
    mode: string
    kedo: any
    onSelect: any
    isSelected: any
    fetchDossierResults: any
    showEmail: boolean
    socketDossierIds: Array<any>
    extraColumns: any
    setInlineEdit: any
    tabsAllowed: any
    refreshing: any
    props: any
    setSocketDossierIds: any
    setQuickEdit: any
    setQuickShow: any
}

const contentClickSelector =
    '.contentData, .displayItem, .list-group-item, .badge'

const interactiveClickSelector = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'option',
    'label',
    '[role="button"]',
    '[role="menuitem"]',
    '[contenteditable="true"]',
    '.MuiButtonBase-root',
    '.dossier-inline-edit',
    '[data-cell-inline-action]',
].join(', ')

const isContentClick = (event): boolean => {
    const target = event.target
    const currentTarget = event.currentTarget

    return (
        target instanceof Element &&
        currentTarget instanceof Element &&
        Boolean(
            target.closest(contentClickSelector) ||
                currentTarget.closest(contentClickSelector)
        )
    )
}

const ContentDossierIndexBody: React.FC<ContentDossierIndexBodyProps> = ({
    listItems,
    dossiers,
    contents,
    actionBtns,
    loadingContent,
    mode,
    kedo,
    onSelect,
    isSelected,
    fetchDossierResults,
    showEmail,
    socketDossierIds,
    subscriptions,
    tabsAllowed,
    extraColumns,
    refreshing,
    setInlineEdit,
    props,
    setSocketDossierIds,
    setQuickEdit,
    setQuickShow,
}): any => {
    const toTop = () => {
        window.scrollTo(0, 0)
    }

    const handleContent = (event, dossier): void => {
        event.stopPropagation()

        if (isInteractiveClick(event) || !isContentClick(event)) {
            return
        }

        if (props.embedded) {
            setQuickEdit(false)
            setQuickShow(true)
            setInlineEdit(dossier.id)
        } else {
            if (
                event.ctrlKey ||
                (navigator.platform == 'MacIntel' && event.metaKey)
            ) {
                window.open(`/contentdossier/${dossier.id}`, '_blank')
                return
            }
            props.onClick(dossier)
            toTop()
        }
    }

    /**
     * Check if the listItem as a specific custom field
     * @param listItem
     * @returns {boolean}
     */
    const isOtherDisplayItemField = (listItem): boolean => {
        if (
            !listItem.def_dossier_link &&
            !listItem.def_dossier_def_field &&
            listItem.settings &&
            listItem.settings.dossier_data
        ) {
            return true
        } else if (
            !listItem.def_dossier_link &&
            !listItem.def_dossier_def_field &&
            listItem.settings &&
            listItem.settings.block
        ) {
            return true
        } else if (
            DisplayItemHelper.isTypeOfField(
                listItem,
                DisplayItemHelper.FIELD_CUSTOMACTIONBTN_TYPE
            )
        ) {
            return true
        }

        return false
    }

    const getValue = (listItem, dossierData, dossier) => {
        const isOther = isOtherDisplayItemField(listItem)
        if (!dossierData && true !== isOther) {
            return ''
        }

        const isListItem = DisplayItemHelper.isTypeOfField(
            listItem,
            DisplayItemHelper.FIELD_LIST_TYPE
        )

        let singleDossierData = dossierData.find(
            (data) => data.content.id === listItem.id
        ) as any

        if (singleDossierData?.content?.skip === true) {
            return ''
        }

        if (singleDossierData && singleDossierData.content) {
            singleDossierData = singleDossierData.content.content
        }

        if (isListItem === true && listItem.settings?.fast_switch === true) {
            return (
                <DisplayItem
                    kedo={kedo}
                    changeValue={() => {
                        //TODO
                    }}
                    content={singleDossierData}
                    dossier={dossier}
                    errors={null}
                    item={listItem}
                    key={listItem.id}
                    mode={DisplayItemHelper.LIST_VIEW}
                />
            )
        }

        if (true === isOther) {
            //Dossier data list field
        } else if (!singleDossierData || singleDossierData.length <= 0) {
            return ''
        }
        return (
            <DisplayItem
                kedo={kedo}
                changeValue={() => {
                    //TODO
                }}
                fetchItems={fetchDossierResults}
                content={singleDossierData}
                dossier={dossier}
                errors={null}
                item={listItem}
                key={listItem.id}
                mode={DisplayItemHelper.LIST_VIEW}
            />
        )
    }

    const renderContentRow = (dossierData, dossier) => {
        const doTransition =
            (mode === 'embeddedList' || mode === 'block') &&
            socketDossierIds.find((item) => item === dossier.id)
                ? true
                : false

        let tabAllowed = true

        if (tabsAllowed.length > 0) {
            const findTab = tabsAllowed.find(
                (tab: { id: any }) => tab.id === dossier.id
            )

            if (findTab) {
                tabAllowed = findTab.tabs_allowed === true
            }
        }

        if (doTransition) {
            tabAllowed = true
        }

        const cursorClass = tabAllowed ? 'pointer' : 'not-allowed'

        return (
            <React.Fragment key={dossier.id}>
                <StyledTableRow
                    key={dossier.id}
                    hover
                    hoverActions
                    variant="compact"
                    verticalAlign="top"
                    className={dossier.archived ? 'archivedDossier' : ''}
                    sx={{
                        borderLeft: doTransition
                            ? '8px solid #bddbf0'
                            : undefined,
                        fontWeight: doTransition ? 'bold' : undefined,
                        cursor: tabAllowed ? 'pointer' : 'not-allowed',
                        ...(dossier.archived && {
                            opacity: 0.6,
                        }),
                    }}
                >
                    <TableCell
                        className={'contentData'}
                        sx={{ width: '3%', minWidth: '30px' }}
                    >
                        {tabAllowed ? (
                            <Checkbox
                                disabled={!tabAllowed}
                                checked={isSelected(dossier)}
                                onChange={(event) => onSelect(event, dossier)}
                                value={dossier.id}
                                size="small"
                                sx={{ p: 0 }}
                            />
                        ) : (
                            <FontAwesomeIcon icon={faEyeSlash} />
                        )}
                    </TableCell>
                    {showEmail === true ? (
                        <TableCell>
                            <ContentDossierSend kedo={kedo} dossier={dossier} />
                        </TableCell>
                    ) : null}
                    <TableCell
                        className={'contentData'}
                        sx={{
                            textAlign: 'center',
                            width: '3%',
                            minWidth: '30px',
                        }}
                    >
                        {subscriptions.find(
                            (item) => item.content_dossier_id === dossier.id
                        ) ? (
                            <FontAwesomeIcon icon={faBell} />
                        ) : null}
                    </TableCell>
                    {listItems.map((listItem) => (
                        <TableCell
                            sx={{ cursor: `${cursorClass}` }}
                            onClick={(event) => {
                                if (!tabAllowed) {
                                    return
                                }

                                if (
                                    DisplayItemHelper.isTypeOfField(
                                        listItem,
                                        DisplayItemHelper.FIELD_CUSTOMACTIONBTN_TYPE
                                    ) === false
                                ) {
                                    setQuickShow(true)
                                    handleContent(event, dossier)
                                }
                            }}
                            className={'contentData'}
                            key={listItem.id}
                        >
                            {getValue(listItem, dossierData, dossier)}
                        </TableCell>
                    ))}
                    {tabAllowed && actionBtns.length > 0 ? (
                        <TableCell className={'contentData'}>
                            <Stack
                                direction="column"
                                spacing={0.5}
                                sx={{
                                    alignItems: 'flex-start',
                                    minWidth: 'max-content',
                                }}
                            >
                                {actionBtns.map((actionBtn) =>
                                    getValue(actionBtn, dossierData, dossier)
                                )}
                            </Stack>
                        </TableCell>
                    ) : null}
                    <TableCell data-cell-inline-edit>
                        {tabAllowed && (
                            <Tooltip title={kedo.t('open_view_mode')} arrow>
                                <CompactButton
                                    data-cell-inline-action
                                    disabled={!tabAllowed}
                                    dense
                                    sx={{ width: '28px', height: '28px' }}
                                    onClick={() => {
                                        const socketDossiers =
                                            socketDossierIds.filter(
                                                (item) => item !== dossier.id
                                            )

                                        setQuickEdit(false)
                                        setQuickShow(true)
                                        setInlineEdit(dossier.id)
                                        setSocketDossierIds(socketDossiers)
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEye} />
                                </CompactButton>
                            </Tooltip>
                        )}
                    </TableCell>
                    <TableCell data-cell-inline-edit>
                        {tabAllowed && (
                            <Tooltip title={kedo.t('open_edit_mode')} arrow>
                                <CompactButton
                                    data-cell-inline-action
                                    disabled={!tabAllowed}
                                    sx={{
                                        ml: 'auto',
                                        width: '28px',
                                        height: '28px',
                                    }}
                                    dense
                                    onClick={() => {
                                        const socketDossiers =
                                            socketDossierIds.filter(
                                                (item) => item !== dossier.id
                                            )

                                        setQuickEdit(true)
                                        setQuickShow(false)
                                        setInlineEdit(dossier.id)
                                        setSocketDossierIds(socketDossiers)
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </CompactButton>
                            </Tooltip>
                        )}
                    </TableCell>
                </StyledTableRow>
            </React.Fragment>
        )
    }

    if (!dossiers || dossiers.length <= 0) {
        return <TableBody />
    }

    if (loadingContent) {
        return (
            <TableBody>
                <StyledTableRow>
                    <TableCell
                        colSpan={listItems.length + extraColumns}
                        sx={{ textAlign: 'center' }}
                    >
                        <LoadingDefault />
                    </TableCell>
                </StyledTableRow>
            </TableBody>
        )
    }

    return (
        <TableBody>
            <StyledTableRow>
                <TableCell
                    className={'seperator-loader'}
                    colSpan={listItems.length + extraColumns + 1}
                    sx={{
                        position: 'relative',
                    }}
                >
                    {refreshing ? (
                        <section
                            className={'seperator-wrapper'}
                            style={{
                                position: 'absolute',
                                top: 0,
                            }}
                        >
                            <div className={'seperator gradient'}></div>
                        </section>
                    ) : null}
                </TableCell>
            </StyledTableRow>
            {dossiers.map((dossier) =>
                renderContentRow(
                    contents.filter((dataItem) => dataItem.id === dossier.id),
                    dossier
                )
            )}
        </TableBody>
    )
}
export default ContentDossierIndexBody
